"use client";

import { useAuth } from "@/contexts/AuthContext";
import { useChatInbox } from "@/hooks/useChatInbox";
import { useEffect } from "react";

/**
 * Sets the PWA app icon badge count to the unified chat unread count using
 * the Badging API. Now reads from the chat inbox (match + team + tournament
 * combined) rather than match-only.
 */
export function useAppBadge() {
  const { user } = useAuth();
  const { totalUnread } = useChatInbox(user?.id);

  useEffect(() => {
    if (!("setAppBadge" in navigator)) return;

    if (totalUnread > 0) {
      navigator.setAppBadge(totalUnread).catch(() => {});
    } else {
      navigator.clearAppBadge().catch(() => {});
    }

    return () => {
      navigator.clearAppBadge().catch(() => {});
    };
  }, [totalUnread]);
}
